"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventCallback = void 0;
const react_1 = require("react");
/**
 * Aimed to be easier to use than useCallback and solve problems raised in this ticket.
 *
 * useEventCallback doesn't need any dependencies list. The returned function should not be used during rendering.
 *
 */
function useEventCallback(fn) {
    const ref = (0, react_1.useRef)(fn);
    // we copy a ref to the callback scoped to the current state/props on each render
    (0, react_1.useLayoutEffect)(() => {
        ref.current = fn;
    });
    return (0, react_1.useCallback)((...args) => ref.current.apply(void 0, args), []);
}
exports.useEventCallback = useEventCallback;
//# sourceMappingURL=event-callback-hook.js.map